const AccessAuthorization = "/access-authorization";
const Competitor = "/competitor";
const Station = "/station";
const Map = "/map";
const Recordings = "/recordings";
const Campaigns = "/campaigns";
const Cohorts = "/cohorts";
const Path = {
  Slash: "/",
  Map: Map,
  Recordings: Recordings,
  Campaigns: Campaigns,
  Cohorts: Cohorts,
  CampaignSurveyBuilder: "/:campaignCode/survey-builder",
  getCampaignSurveyBuilder: (campaignCode) =>
    `/${encodeURIComponent(String(campaignCode || "").trim())}/survey-builder`,
  Auth: "/auth",
  AccessAuthorization: AccessAuthorization,
  UserAccess: `${AccessAuthorization}/user-access`,
  Competitor: Competitor,
  CompetitorList: `${Competitor}/list`,
  AddCompetitor: `${Competitor}/add`,
  EditCompetitor: `${Competitor}/edit`,
  ViewCompetitor: `${Competitor}/view`,
  StationList: `${Station}/list`,
  AddStation: `${Station}/add`,
  EditStation: `${Station}/edit`,
  ViewStation: `${Station}/view`,
};

export default Path;
